import { Injectable } from "@angular/core";
import { Subject } from "rxjs";

import { ButtonState } from "./button";

@Injectable()
export class RoyaltyButtonService {
	private loaderSubject = new Subject<ButtonState>();

	loaderState = this.loaderSubject.asObservable();

	constructor() {}

	show() {
		this.loaderSubject.next(<ButtonState>{ isProcessing: true });
	}

	hide() {
		this.loaderSubject.next(<ButtonState>{ isProcessing: false });
	}
}
